import type { ReactNode } from 'react';
import { Icon } from './Icon';

interface MetricProps {
  label: string;
  value: ReactNode;
  sublabel?: string;
  delta?: string;
  deltaTone?: 'up' | 'down' | 'flat';
  hint?: string;
}

export function Metric({ label, value, sublabel, delta, deltaTone = 'flat', hint }: MetricProps) {
  const deltaColor =
    deltaTone === 'up'
      ? '#15803d'
      : deltaTone === 'down'
        ? 'var(--bx-error)'
        : 'var(--bx-text-muted)';
  const deltaIcon: 'arrowUp' | 'arrowDown' | 'arrowRight' =
    deltaTone === 'up' ? 'arrowUp' : deltaTone === 'down' ? 'arrowDown' : 'arrowRight';

  return (
    <div
      style={{
        background: 'var(--bx-card-bg)',
        border: '1px solid var(--bx-border-muted)',
        borderRadius: 'var(--bx-radius-lg)',
        boxShadow: 'var(--bx-shadow-card)',
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        minWidth: 0,
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: 'var(--bx-text-muted)',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          fontWeight: 700,
        }}
      >
        {label}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          gap: 8,
          flexWrap: 'wrap',
          minWidth: 0,
        }}
      >
        <div
          style={{
            fontSize: 28,
            fontWeight: 700,
            color: 'var(--bx-text-heading)',
            fontVariantNumeric: 'tabular-nums',
            letterSpacing: '-0.02em',
            lineHeight: 1.05,
          }}
        >
          {value}
        </div>
        {sublabel && (
          <div style={{ fontSize: 12.5, color: 'var(--bx-text-muted)' }}>{sublabel}</div>
        )}
      </div>
      {(delta || hint) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {delta && (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                fontSize: 11.5,
                fontWeight: 600,
                color: deltaColor,
              }}
            >
              <Icon name={deltaIcon} size={10} />
              {delta}
            </span>
          )}
          {hint && (
            <span style={{ fontSize: 11.5, color: 'var(--bx-text-muted)' }}>{hint}</span>
          )}
        </div>
      )}
    </div>
  );
}
